import { Box, BoxProps, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, alpha } from '@mui/material';
import { EligibilityFailMessage } from '../../store/features/apply/types';
import { AppIcon } from '../app-icon/AppIcon';
import { CheckCircleIcon, TimesCircleIcon } from '../../assets/icons';
import { parseEligibilityOperator, parseEligibilityValue } from '../../utils/eligibility';

interface EligibilityFailCriteriaListProps extends BoxProps {
  messages: EligibilityFailMessage[];
}
export const EligibilityFailCriteriaList: React.FC<EligibilityFailCriteriaListProps> = ({ messages, ...boxProps }) => {
  const getCheckItemLabel = (name: string, criteria: EligibilityFailMessage['criteria']): string => {
    const criterionWithSameName = criteria.find((criterion) => criterion.name === name);
    if (criterionWithSameName) return criterionWithSameName.label;
    return name;
  };

  return messages.length > 0 ? (
    <Box {...boxProps}>
      <TableContainer>
        <Table sx={{ '.MuiTableCell-root': { px: 3, py: 1.5, borderColor: 'grey.100' } }}>
          <TableHead>
            <TableRow sx={{ '.MuiTableCell-head': { fontWeight: 'Bold' } }}>
              <TableCell>Criteria</TableCell>
              <TableCell>Qualification</TableCell>
              <TableCell>Eligible</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messages.map((message, idx) => (
              <TableRow key={idx} sx={{ bgcolor: (theme) => alpha(theme.palette[message.type].light, 0.125) }}>
                <TableCell>
                  <Box sx={{ listStyle: message.criteria.length > 1 ? 'inside' : 'none' }} component="ul">
                    {message.criteria.map((criterion, criterionIdx) => (
                      <Box component="li" key={criterionIdx}>
                        {criterion.label} {parseEligibilityOperator(criterion.operator)}{' '}
                        {parseEligibilityValue(criterion.value)}
                      </Box>
                    ))}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      listStyle: !!message.checkValue && Object.keys(message.checkValue).length > 1 ? 'inside' : 'none',
                    }}
                    component="ul"
                  >
                    {message.checkValue ? (
                      Object.keys(message.checkValue).map((key) => (
                        <Box component="li" key={key}>
                          {getCheckItemLabel(key, message.criteria)}:{' '}
                          {parseEligibilityValue(message.checkValue ? message.checkValue[key] : null)}
                        </Box>
                      ))
                    ) : (
                      <Box component="li">---</Box>
                    )}
                  </Box>
                </TableCell>
                <TableCell sx={{ color: `${message.type}.main`, fontSize: '2rem' }}>
                  <AppIcon fontSize="inherit" Icon={message.type === 'success' ? CheckCircleIcon : TimesCircleIcon} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  ) : null;
};
